// extracted by mini-css-extract-plugin
export default {"wrap":"iN-z","fullWidth":"jN-z","hideOnDesktop":"kN-z","content":"lN-z","hasOpenedNav":"mN-z","crumbsList":"nN-z","dropdownsWrap":"oN-z"};